import React from 'react';

import {assert} from 'Asserts';
import {
  CreateMixtureGroupExtras,
  isMixtureGroup,
  MixtureGroupMetadata,
} from 'notebook/integrations/registry/MixtureGroupConstants';
import {MixtureNoteLinkedGroupAdapter} from 'notebook/integrations/registry/MixtureNoteLinkedGroupAdapter';
import InsertParentMixtureInstructionsButton from 'notebook/notes/groups/action-functions/InsertParentMixtureInstructionsButton';
import makeCustomGroupButtonActionFunction from 'notebook/notes/groups/action-functions/makeCustomGroupButtonActionFunction';
import {GroupActionFunctionParameters} from 'notebook/notes/groups/NoteLinkedGroupConstants';

function isInsertActionHidden({
  noteLinkedGroup,
  noteLinkedGroupAdapter,
}: GroupActionFunctionParameters<MixtureGroupMetadata, CreateMixtureGroupExtras>): boolean {
  // Should be hidden if the schema for the mixture group does not have a parent link mixture field
  const parentLinkFieldId = (
    noteLinkedGroupAdapter as MixtureNoteLinkedGroupAdapter
  ).getMixtureMetadataStructuredTable(noteLinkedGroup).metadata.parentLinkMixtureFieldId;
  return parentLinkFieldId == null;
}

const insertParentMixtureInstructionsActionFunction = makeCustomGroupButtonActionFunction<
  MixtureGroupMetadata,
  CreateMixtureGroupExtras
>({
  getHidden: isInsertActionHidden,
  renderToolbarButton: (params) => {
    const {noteLinkedGroup} = params;
    assert(
      isMixtureGroup(noteLinkedGroup),
      'Insert mixture instructions action can only be used in a mixture group'
    );
    return <InsertParentMixtureInstructionsButton {...params} />;
  },
  renderOverflowMenuItem: () => {
    throw new Error('Not implemented');
  },
});

export default insertParentMixtureInstructionsActionFunction;
